import { IonButton, IonButtons, IonCard, IonCardContent, IonCardHeader, IonCardSubtitle, IonCardTitle, IonCol, IonContent, IonGrid, IonHeader, IonIcon, IonInfiniteScroll, IonInfiniteScrollContent, IonLabel, IonLoading, IonPage, IonRefresher, IonRefresherContent, IonRow, IonSegmentButton, IonSlide, IonSlides, IonTitle, IonToolbar, useIonViewDidEnter } from '@ionic/react';
import { albums, arrowBack, calendar, flag, informationCircle } from 'ionicons/icons';
import React, { useContext, useRef, useState } from 'react';
import { useHistory } from 'react-router-dom';
import { listaConvidados, requestService } from '../../../../../Utils/Services';
import { MessageContext } from '../../../../../contexts/MessageContext';
import './Compartilhados.css';

const Compartilhados: React.FC = () => {

  const history = useHistory();
  const [aba, setAba] = useState("proximos");
  const [arrayCompartilhados, setArrayCompartilhados] = useState<any>([]);
  const [chamadaRealizada, setChamadaRealizada] = useState(false);
  const [desabilitarInfiniteScroll, setDesabilitarInfiniteScroll] = useState(false);
  const [projetosk, setProjetosk] = useState("");
  const [showLoading, setShowLoading] = useState(true);
  const { esconderMenu, setEsconderMenu } = useContext(MessageContext);

  useIonViewDidEnter(() => {
    setChamadaRealizada(false);
    loadItens();
    window.localStorage.setItem("compartilhado", "true");
    setEsconderMenu(true);
  });

  let slides = useRef(document.createElement('ion-slides'));

  const nextSlide = () => {
    slides.current.getActiveIndex().then(
      isEnd => {
        if (isEnd === 1)
          setAba("anteriores")
        else
          setAba("proximos")
      }
    );
  }

  function carregarDetalhes(configsLoja: any, projetoid: any, empresaid: any, abrirInserirAgendamento: boolean) {
    setChamadaRealizada(false);
    history.push("ordens/ordensdetalhes", { projetoid: projetoid, empresaid: empresaid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: abrirInserirAgendamento })
  }

  function carregarWorkflow(configsLoja: any, projetoid: any) {

    setChamadaRealizada(false);
    history.push("ordens/ordensworkflow", { projetoid: projetoid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: false })

  }

  function carregarAgendamentos(configsLoja: any, projetoid: any, empresaid: any, abrirInserirAgendamento: boolean) {
    setChamadaRealizada(false);
    history.push("ordens/ordensagendamentos", { projetoid: projetoid, empresaid: empresaid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: abrirInserirAgendamento })
  }

  function carregarOperacoes(configsLoja: any, projetoid: any, empresaid: any, abrirInserirAgendamento: boolean) {
    setChamadaRealizada(false);
    history.push("ordens/ordensoperacoes", { projetoid: projetoid, empresaid: empresaid, configs: JSON.stringify(configsLoja), abrirInserirAgendamento: abrirInserirAgendamento })
  }


  const loadItens = () => {

    if (!chamadaRealizada) {
      setChamadaRealizada(true);
      carregarCompartilhados();
    }

    if (arrayCompartilhados === undefined || arrayCompartilhados.length === 0) {
      return (
        <IonCard key="primeira">
          <IonCardHeader >
            <IonCardTitle>{"Ainda não teve nenhum compartilhamento de " + window.localStorage.getItem("servicoTipoPlural") || "Pedidos"}.</IonCardTitle>
            <IonCardSubtitle></IonCardSubtitle>
            <IonLabel></IonLabel>
          </IonCardHeader>
          <IonCardContent>
          </IonCardContent>
        </IonCard>
      );
    }

    return arrayCompartilhados.map((value: any, index: any, arr: any) =>
      (index === 0 || (arr[index - 1] && new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10) !== new Date(arr[index - 1].dataCadastro).toLocaleString('pt-BR').substring(0, 10))) ?
        (<>
          <IonCard className={"card"} key={value.dataCadastro + index.toString()}>
            <IonCardHeader key={value.dataCadastro}>
              <IonCardTitle>
                <div className={"cabecalho"} >{new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10) === new Date().toLocaleString('pt-BR').substring(0, 10) ? "Hoje" : new Date(value.dataCadastro).toLocaleString('pt-BR').substring(0, 10)}</div>
              </IonCardTitle>
            </IonCardHeader>
          </IonCard>
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>

                {value.empresaNome || "não identificado"}



                {/* <div className='informacoes'>
                  <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (value.empresaTelefone)}>
                    <IonIcon slot="icon-only" icon={chatbubbles} />
                  </a>
                </div> */}
              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent style={{ paddingBottom: 0 }}>
              <div hidden={value.layoutSimplificado}>
                <IonLabel>{value && value.servicoTipo ? value.servicoTipo : "Projeto"}: {value.nomeProjeto}
                </IonLabel>
              </div>


            </IonCardContent>

            <IonGrid style={{ padding: 0 }}>
              <IonRow >

                <IonCol size={value.layoutSimplificado ? '4' : '3'}>
                  <IonSegmentButton onClick={() => { carregarDetalhes(value.configWorkflow, value.sk.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={informationCircle}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Detalhes</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size='3' hidden={value.layoutSimplificado}>
                  <IonSegmentButton onClick={() => { carregarWorkflow(value.configWorkflow, value.sk.replaceAll(/#/g, '%23')); }}>
                    <IonIcon icon={albums}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>{value && value.nomeLinhaDoTempo ? value.nomeLinhaDoTempo : "Linha do tempo"}</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '4' : '3'}>

                  <IonSegmentButton onClick={() => { carregarAgendamentos(value.configWorkflow, value.sk.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={calendar}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Agenda</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '4' : '3'}>
                  <IonSegmentButton onClick={() => { carregarOperacoes(value.configWorkflow, value.sk.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={flag}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Operações</IonLabel>

                  </IonSegmentButton>

                </IonCol>

              </IonRow>
            </IonGrid>
          </IonCard>
        </>
        ) :
        (
          <IonCard key={"cartao" + value.id + index.toString()}>
            <IonCardHeader key={value.id}>
              <IonCardTitle>

                {value.empresaNome || "não identificado"}



                {/* <div className='informacoes'>
                  <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (value.empresaTelefone)}>
                    <IonIcon slot="icon-only" icon={chatbubbles} />
                  </a>
                </div> */}


              </IonCardTitle>
            </IonCardHeader>
            <IonCardContent style={{ paddingBottom: 0 }}>
              <div hidden={value.layoutSimplificado}>
                <IonLabel>{value && value.servicoTipo ? value.servicoTipo : "Projeto"}: {value.nomeProjeto}
                </IonLabel>
              </div>



            </IonCardContent>

            <IonGrid style={{ padding: 0 }}>
              <IonRow >

                <IonCol size={value.layoutSimplificado ? '4' : '3'}>
                  <IonSegmentButton onClick={() => { carregarDetalhes(value.configWorkflow, value.sk.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={informationCircle}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Detalhes</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size='3' hidden={value.layoutSimplificado}>
                  <IonSegmentButton onClick={() => { carregarWorkflow(value.configWorkflow, value.sk.replaceAll(/#/g, '%23')); }}>
                    <IonIcon icon={albums}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>{value && value.nomeLinhaDoTempo ? value.nomeLinhaDoTempo : "Linha do tempo"}</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '4' : '3'}>

                  <IonSegmentButton onClick={() => { carregarAgendamentos(value.configWorkflow, value.sk.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={calendar}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Agenda</IonLabel>

                  </IonSegmentButton>
                </IonCol>
                <IonCol size={value.layoutSimplificado ? '4' : '3'}>
                  <IonSegmentButton onClick={() => { carregarOperacoes(value.configWorkflow, value.sk.replaceAll(/#/g, '%23'), value.gsi2pk.replaceAll(/#/g, '%23'), false); }}>
                    <IonIcon icon={flag}></IonIcon>
                    <IonLabel class='ion-text-wrap' style={{ textTransform: 'capitalize', fontSize: '12px' }}>Operações</IonLabel>

                  </IonSegmentButton>

                </IonCol>

              </IonRow>
            </IonGrid>
          </IonCard>
        )
    );

  }

  function carregarCompartilhados() {
    const consultar = async () => {

      requestService(listaConvidados.url, {
        method: listaConvidados.method,
        headers: [
          ["token", window.localStorage.getItem("token")],
          ["perfil", window.localStorage.getItem("perfil")],
          ["marca", window.localStorage.getItem("marca") || ""],
        ],
        credentials: 'include'
      },
        history,
        (response: any) => {
          setArrayCompartilhados(response.Items);
          if (response.LastEvaluatedKey) {
            setProjetosk(response.LastEvaluatedKey.sk);
            setDesabilitarInfiniteScroll(false);
          }
          else {
            setProjetosk("");
            setDesabilitarInfiniteScroll(true);
          }
          setShowLoading(false);
        },
        (error: any) => {
          setShowLoading(false);
        });
    }

    consultar();
  }

  async function carregarMaisCompartilhados($event: CustomEvent<void>) {

    await carregarMaisCompartilhadosChamada().then(() => {
      console.log("terminou resultados");
    });
    ($event.target as HTMLIonInfiniteScrollElement).complete();
  }

  async function carregarMaisCompartilhadosChamada() {

    requestService(listaConvidados.url + "?sk=" + projetosk, {
      method: listaConvidados.method,
      headers: [
        ["token", window.localStorage.getItem("token")],
        ["perfil", window.localStorage.getItem("perfil")],
        ["marca", window.localStorage.getItem("marca") || ""],
      ],
      credentials: 'include'
    },
      history,
      (response: any) => {
        console.log(arrayCompartilhados.length);
        for (let i = 0; i < response.Items.length; i++) {
          console.log("resultados");
          arrayCompartilhados.push(response.Items[i]);
        }
        console.log(arrayCompartilhados.length);
        if (response.LastEvaluatedKey) {
          setProjetosk(response.LastEvaluatedKey.sk);
          setDesabilitarInfiniteScroll(false);
        }
        else {
          setProjetosk("");
          setDesabilitarInfiniteScroll(true);
          console.log("finalizou");
        }
      },
      (error: any) => {
        console.log(error);
        if (error.status === 426) { // atualizar versao
          history.replace("/atualizar");
        }
        else if (error !== 408) {
          history.replace("/primeiroacesso/");
        }
      });
  }

  function doRefresh(event: any) {
    carregarCompartilhados();
    setTimeout(() => {
      event.detail.complete();
    }, 1200);
  }

  return (
    <IonPage>

      <IonHeader>
        <IonToolbar color="primary">
          <IonButtons slot="start">
            <IonButton onClick={() => { history.goBack();/*.replace("/empresa/operacoes", { recarregar: false }); */ }}>
              <IonIcon slot="icon-only" icon={arrowBack} />
            </IonButton>
          </IonButtons>
          <IonTitle>Compartilhado</IonTitle>

        </IonToolbar>
      </IonHeader>

      <IonContent className={"Compartilhados"}>

        {/* <IonFab vertical="bottom" horizontal="end" slot="fixed" edge style={{ "bottom": "20px" }} hidden={window.localStorage.getItem("empresaTelefone") ? false : true}>

          <IonFabButton color="tertiary">
            <a target='_blank' href={"https://api.whatsapp.com/send?phone=" + (window.localStorage.getItem("empresaTelefone") || "")}>
              <IonIcon color="light" size="large" icon={chatbubbles} />
            </a>
          </IonFabButton>
        </IonFab> */}

        <IonSlides className={"CompartilhadosSlides"} ref={slides} onIonSlideWillChange={nextSlide}>
          <IonSlide key="slide1">
            <div style={{ padding: "6px" }}>
              {loadItens()}
            </div>
          </IonSlide>
        </IonSlides>

        <IonRefresher slot="fixed" onIonRefresh={doRefresh}>
          <IonRefresherContent></IonRefresherContent>
        </IonRefresher>

        <IonInfiniteScroll
          threshold="100px"
          onIonInfinite={(e: CustomEvent<void>) => carregarMaisCompartilhados(e)}
          position="bottom"
          disabled={desabilitarInfiniteScroll}>
          <IonInfiniteScrollContent loadingSpinner="dots" loadingText="Carregando mais operações..."></IonInfiniteScrollContent>
        </IonInfiniteScroll>
        <IonLoading
          cssClass='my-custom-class'
          isOpen={showLoading}
          onDidDismiss={() => { setShowLoading(false); }}
          spinner='circles'
        />
      </IonContent>





    </IonPage>
  );
};

export default Compartilhados;
